"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Table = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

require("./Table.scss");

var _TableRow = _interopRequireDefault(require("./TableRow/TableRow"));

var _GenericRow = _interopRequireDefault(require("./TableRow/GenericRow"));

var _scrollService = require("../../services/scrollService");

var _DataStatus = _interopRequireDefault(require("../DataStatus/DataStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Table = function Table(props) {
  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      activeRow = _useState2[0],
      setActiveRow = _useState2[1];

  var fillHeader = function fillHeader(items) {
    if (items[0] && typeof items[0] === 'string') {
      return items.map(function (item, index) {
        var classes = 'cell';

        if (typeof items[index] === 'function') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: items[index].name
          }, item());
        }

        if (props.structure.rowFormat && props.structure.rowFormat[props.structure.dataKeys[index]] && props.structure.rowFormat[props.structure.dataKeys[index]].hasPriority) {
          classes = classes + ' priority';
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item,
          className: classes
        }, item);
      });
    } else if (items[0]) {
      return items.map(function (item) {
        return item.format();
      });
    }
  };

  var populateRows = function populateRows() {
    var referenceData = props.data;

    if (props.data && props.data[0] && props.data[0].reseller_trial_set) {
      referenceData = props.data[0].reseller_trial_set;
    }

    return referenceData.map(function (item, index) {
      var uniqueID = item.uniqueID ? item.uniqueID : index + '-' + (item.Name || item.ship_to_name || item.reseller_name);
      var tempProps = {
        id: uniqueID,
        rowContent: item,
        handleClick: rowClickHandler,
        isActive: uniqueID === activeRow,
        header: props.headers,
        structure: props.structure,
        index: index
      };

      if (props.subRowStructure) {
        tempProps.subRowStructure = props.subRowStructure;
      }

      if (props.structure.hasTableRow) {
        return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], _extends({
          key: uniqueID
        }, tempProps));
      } else {
        return /*#__PURE__*/_react["default"].createElement(_GenericRow["default"], _extends({
          key: uniqueID
        }, tempProps));
      }
    });
  };

  var rowClickHandler = function rowClickHandler(id, isSubmenu) {
    if (!isSubmenu) {
      if (id !== activeRow) {
        if (props.dropdownCallback) {
          props.dropdownCallback(id);
        }

        setActiveRow(id);
      } else {
        setActiveRow(null);
      }
    }
  };

  var handleScroll = function handleScroll(e) {
    (0, _scrollService.scrollPercent)(e, props.onScrollAPI);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table",
    onScroll: handleScroll
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tableHeader"
  }, fillHeader(props.structure.headers)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tableBody"
  }, props.dataStatus === 'DISABLED' && populateRows()), props.dataStatus !== 'DISABLED' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tableLoader"
  }, /*#__PURE__*/_react["default"].createElement(_DataStatus["default"], {
    status: props.dataStatus
  })));
};

exports.Table = Table;
var _default = Table;
exports["default"] = _default;
Table.propTypes = {
  subRowStructure: _propTypes.object,
  headers: (0, _propTypes.arrayOf)(_propTypes.string),
  data: (0, _propTypes.arrayOf)(_propTypes.any).isRequired,
  dropdownCallback: _propTypes.func,
  onScrollAPI: _propTypes.func,
  dataStatus: _propTypes.string,
  structure: (0, _propTypes.shape)({
    clickable: _propTypes.bool,
    customMemoAreEqual: _propTypes.func,
    hasIcon: _propTypes.bool,
    hasSubRow: _propTypes.bool,
    headers: (0, _propTypes.arrayOf)(_propTypes.any),
    rowFormat: _propTypes.object
  })
};